import React, { Component, Fragment } from 'react';
import { ErrorMessage, Form, Formik, Field } from 'formik';
import CustomLoader from '../../../common/CustomLoader';
import SwitchTenantModalRule from './SwitchTenantModalRule';
import { processRediretRule, getFilteredArray } from './util';
import { getFieldInfoByName } from '../collection/Util';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import {
  getFieldDescriptionInfoByName,
  getFieldDescriptionTextByName,
} from '../../ActionFormUtils';
import { builderSurfaceJsonContentHeader } from '../../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { pluginCode } from 'drapcode-constant';

export default class SwitchTenantModal extends Component {
  state = {
    roles: {},
    params: [],
  };

  componentDidMount = () => {
    const { eventAction, version, projectId } = this.props;
    const dbParams = eventAction.parameters.find((param) => {
      return param.name === 'redirectRules';
    });
    const uri = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/role/`;
    const header = builderSurfaceJsonContentHeader(projectId);
    const doRequest = axios.get(uri, header);
    doRequest.then((res) => {
      this.setState({
        roles: res.data,
        params:
          dbParams && dbParams.value.length
            ? dbParams.value
            : [
                {
                  id: 1,
                  role: '',
                  page: '',
                },
              ],
      });
    });
  };

  createNewParamRow = (rowObj) => {
    const params = processRediretRule(this.state.params, rowObj);
    this.setState({ params });
  };

  createActionSettingsSchema = (actionData, eventAction) => {
    let schema = {};
    actionData.args.forEach((args) => {
      const dbParameters = eventAction.parameters.find((param) => {
        return param.name === args.name;
      });
      schema[args.name] = dbParameters ? dbParameters.value : '';
    });
    return schema;
  };

  getPageOptions = () => {
    const { pages } = this.props.events;
    const pageOptions =
      pages.length > 0 ? pages.map((item) => ({ value: item.slug, label: item.name })) : [];
    return pageOptions;
  };

  handleCollectionChange = (setFieldValue, values, value) => {
    setFieldValue('fieldName', '');
    this.setState({
      params: [
        {
          id: 1,
          role: '',
          page: '',
        },
      ],
    });
  };

  handleFieldChange = (name, value) => {
    this.setState({
      params: [
        {
          id: 1,
          role: '',
          page: '',
        },
      ],
    });
  };

  handleSubmit = (values) => {
    const { actionData } = this.props;
    const { params } = this.state;

    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      parameters.push({ name: value, value: values[value], type: action.type });
    });
    parameters.push({
      name: 'redirectRules',
      value: getFilteredArray(params),
      type: 'array',
    });

    let actionFormData = this.props.eventAction;
    actionFormData.parameters = parameters;
    this.props.actions.updateAction({
      projectId: this.props.projectId,
      version: this.props.version,
      eventId: this.props.selectedEvent.uuid,
      data: actionFormData,
    });
    this.props.hideModal();
  };

  showAlertMessage = () => {
    const { projectId, version } = this.props;
    return (
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
        <div className="alert alert-info small">
          <div className="alert-icon">
            <i className="wb webconnect-info-circle" style={{ verticalAlign: '1px' }}></i>
          </div>
          To redirect pages based on tenant roles, configure User Settings in
          <Link to={`/plugin/${version}/v/${projectId}`}>
            <span style={{ textDecoration: 'underline' }}>&nbsp;Multi Tenant Saas plugin</span>{' '}
            <i className="wb webconnect-box-arrow-up-right"></i>
          </Link>
        </div>
      </div>
    );
  };

  render() {
    const { eventAction, actionData, events, projectId, version } = this.props;
    const { collections, pages, plugins } = events || '';
    const multiTenantSaasPlugin =
      plugins && plugins.find((e) => e.code === pluginCode.MULTI_TENANT_SAAS);
    let isUserSettingsConfigured = false;
    if (multiTenantSaasPlugin) {
      const { setting } = multiTenantSaasPlugin;
      const { userSettingsCollection } = setting;
      if (userSettingsCollection) isUserSettingsConfigured = true;
    }

    return (
      <Fragment>
        <Formik
          enableReinitialize={true}
          initialValues={this.createActionSettingsSchema(actionData, eventAction)}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleSubmit(values);
          }}
        >
          {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
            <Form>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Alert Message"
                      icon="text"
                      infoIcon={true}
                      infoDescription={getFieldInfoByName('confirmationMessage')}
                    >
                      <Field
                        type="text"
                        name={'confirmationMessage'}
                        className="form-control form-control-sm"
                        autoComplete="off"
                        placeholder={'Alert Message (Optional)'}
                      />
                      <ErrorMessage name={'confirmationMessage'}>
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </FormFieldWithLabel>
                    <small className="input-group" style={{ paddingLeft: '12%' }}>
                      {getFieldDescriptionTextByName({ name: 'confirmationMessage' })}
                    </small>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Success Message"
                      icon="text"
                      infoIcon={true}
                      infoDescription={getFieldInfoByName('successMessage')}
                    >
                      <Field
                        type="text"
                        name={'successMessage'}
                        className="form-control form-control-sm"
                        autoComplete="off"
                        placeholder={'Success Message (Optional)'}
                      />
                    </FormFieldWithLabel>
                    <small className="input-group" style={{ paddingLeft: '12%' }}>
                      {getFieldDescriptionTextByName({ name: 'successMessage' })}
                    </small>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Error Message"
                      icon="text"
                      infoIcon={true}
                      infoDescription={getFieldInfoByName('errorMessage')}
                    >
                      <Field
                        type="text"
                        name={'errorMessage'}
                        className="form-control form-control-sm"
                        autoComplete="off"
                        placeholder={'Error Message (Optional)'}
                      />
                    </FormFieldWithLabel>
                    <small className="input-group" style={{ paddingLeft: '12%' }}>
                      {getFieldDescriptionTextByName({ name: 'errorMessage' })}
                    </small>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Skip Page Reload"
                      icon="boolean-toggle"
                      infoIcon={true}
                      infoDescription={getFieldInfoByName('skipPageReload')}
                    >
                      <div className="form-check form-control-sm">
                        <label className="form-check-label">
                          <Field
                            type="checkbox"
                            name={'skipPageReload'}
                            className="form-check-input"
                            title={'Skip Page Reload'}
                          />
                          {'Skip Page Reload'}
                          <span className="form-check-sign" style={{ top: '1px' }}>
                            <span className="check"></span>
                          </span>
                        </label>
                        <ErrorMessage name={'skipPageReload'}>
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>
                      </div>
                      {getFieldDescriptionInfoByName({
                        name: 'skipPageReload',
                        label: 'Skip Page Reload',
                      })}
                    </FormFieldWithLabel>
                  </div>
                </div>
                {!isUserSettingsConfigured && this.showAlertMessage()}
                {isUserSettingsConfigured && (
                  <div className="col-12">
                    <hr />
                    <label>Page Redirection Rules</label>
                    {getFieldDescriptionInfoByName({
                      name: 'tenantRoleRedirectionRule',
                      label: 'Page Redirection Rule',
                    })}
                    <SwitchTenantModalRule
                      createNewParamRow={this.createNewParamRow}
                      params={this.state.params}
                      collections={collections}
                      pages={pages}
                      projectId={projectId}
                      version={version}
                      roles={this.state.roles}
                      eventAction={eventAction}
                    />
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="text-right">
                    <div className="float-left">
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={this.props.hideModal}
                      >
                        <span>
                          <i className="wb webconnect-times"></i>&nbsp;Cancel
                        </span>
                      </button>
                    </div>
                    <div className="float-right">
                      <button type="submit" className="btn btn-theme-submit btn-sm">
                        <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                        <CustomLoader loading={this.props.showLoaderForAction} />
                      </button>
                    </div>
                    <div className="clearfix"></div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Fragment>
    );
  }
}
